document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".bio-toggle");

  toggleButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const bio = this.nextElementSibling;

      // Toggle visibility
      bio.classList.toggle("show");

      // Update button text
      this.textContent = bio.classList.contains("show") ? "Hide Bio" : "Read Bio";
    });
  });
});
